// eslint-disable-next-line no-unused-vars
import React from 'react';

export default () => {
  // gather audiences from tealium
  let audiences;
  try{
    audiences = Object.values(JSON.parse(localStorage.getItem('teal_adbe_enrichment_data')).audiences).toString().replace(/,/g,'|').toLowerCase();
  }catch(err){
    // do nothing
    console.error(`Error capturing audiences from Tealium with error message: ${err}`);
  }

  // set chosen audiences array for audiences that should not receive the SEC form
  const audiencesArray = [
    'ua_utm-campaign-lifeandmoney',
    'ua_email-capture-sign-up',
  ];
  let hideForAudiences = false;
  let hideTheSuspectEmailCaptureForm = false;
  // check for any audience matches coming from tealium
  if (audiences) {
    audiencesArray.forEach(audience => {
      if (audiences.includes(audience)) {
        hideForAudiences = true;
      }
    });
  }

  // final check to determine if we should hide the SEC form
  if(hideForAudiences){
    hideTheSuspectEmailCaptureForm = true;
  }

  return hideTheSuspectEmailCaptureForm;
};
